import { colors, intl, ui } from '@beelday/common'
import { css } from '@emotion/react'
import { useFormik } from 'formik'
import { v4 as uuidv4 } from 'uuid'
import { YouTubeStreamDefinition } from './model'
import { extractYouTubeVideoId } from './youtube-utils'

type Props = {
	onCreate: (definition: YouTubeStreamDefinition) => void
}

export const YouTubeStreamForm = ({ onCreate }: Props): JSX.Element => {
	const formik = useFormik<YouTubeStreamDefinition>({
		initialValues: {
			id: uuidv4(),
			link: '',
			name: '',
			description: '',
		},
		validate: values => {
			const errors: Partial<YouTubeStreamDefinition> = {}
			if (!values.name) {
				errors.name = 'Required'
			}
			if (!values.link) {
				errors.link = 'Required'
			} else if (!extractYouTubeVideoId(values.link)) {
				errors.link = 'Invalid link'
			}
			return errors
		},
		onSubmit: values => {
			onCreate({
				...values,
				link: values.link.trim(),
			})
		},
	})

	return (
		<ui.FlexColumnCenter style={{ width: '100%', rowGap: '20px' }}>
			<ui.InputLabeled
				label={<intl.Translate>youtube_stream.form.name</intl.Translate>}
				invalid={!!formik.errors.name}
				css={css`
					width: 100%;
				`}
			>
				<ui.Input
					name="name"
					value={formik.values.name}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					maxLength={50}
					css={css`
						width: 100%;
					`}
				/>
			</ui.InputLabeled>
			<ui.InputLabeled
				label={<intl.Translate>youtube_stream.form.link</intl.Translate>}
				invalid={!!formik.errors.link}
				css={css`
					width: 100%;
				`}
			>
				<ui.Input
					name="link"
					value={formik.values.link}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					css={css`
						width: 100%;
					`}
				/>
			</ui.InputLabeled>
			<ui.InputLabeled
				label={<intl.Translate>youtube_stream.form.description</intl.Translate>}
				invalid={!!formik.errors.description}
				css={css`
					width: 100%;
				`}
			>
				<ui.ExpandableTextAreaWithCounter
					name="description"
					maxHeight={200}
					value={formik.values.description}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					css={css`
						width: 100%;
						min-height: 100px;
						border: 1px solid ${colors.borderLightGray};
						font-size: 14px;
					`}
					limit={300}
				/>
			</ui.InputLabeled>
			<ui.Button
				disabled={Object.entries(formik.errors).length > 0 || !formik.dirty}
				style={{ width: '200px' }}
				onClick={formik.submitForm}
			>
				<intl.Translate>submit</intl.Translate>
			</ui.Button>
		</ui.FlexColumnCenter>
	)
}
